import { useMemo } from 'react';
import { computeCagedWindow } from '../utils/cagedWindow';
import { CagedLetter } from '../data/caged';

export function useCagedWindow(
  scaleRoot: string | null,
  letter: CagedLetter | null,
): { lowFret: number; highFret: number } | null {
  return useMemo(() => computeCagedWindow(scaleRoot, letter), [scaleRoot, letter]);
}
